import React from 'react';
import './ResultPlace.css';

 const ResultPlace = (props) => {
     
    let results = props.rightAnswer.map((item, index) => {
        return (
            <div key = {index}>
    {item === 0 ? ( props.step === index ? <div className = 'resultCircle resultActive'></div> : <div className = 'resultCircle'></div>) : (item === 1 ? <div className = 'resultCircle resultCorrect'></div> : <div className = 'resultCircle resultWrong'></div>) }
            </div>
        
        );
    });
    return (
        <div className= 'resultConteiner' >
            {results}
        </div>
    );
  };

export default ResultPlace;